module.exports = __webpack_public_path__ + "assets/img/hideActive.a0f5cdab.svg";